export var EnumPosition = /*#__PURE__*/function (EnumPosition) {
  EnumPosition["top"] = "top";
  EnumPosition["bottom"] = "bottom";
  return EnumPosition;
}({});

/**  提示位置 默認值top  */

/**icon的类型 */